import { boxShadow, Button, radiusHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { useContext, useEffect, useState } from 'react';
import Plus from '../icons/Plus';
import Minus from '../icons/Minus';
import { MINIMUM_ZOOM_LEVEL } from '../../config';
import { PcaMapContext } from '../../../../../contexts/PcaMapContext/PcaMapContext';

const ZoomInButton = styled(Button)`
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;
const ZoomOutButton = styled(Button)`
  border-top-left-radius: 0;
  border-top-right-radius: 0;
`;

const StyledZoomButtons = styled.div`
  ${boxShadow.mapBoxShadow}
  border-radius: ${radiusHelper('full')};
  > button {
    box-shadow: none;
  }
`;
const MAXIMUM_ZOOM_LEVEL_DEFAULT = 22;
const MAXIMUM_ZOOM_LEVEL_SATELLITE = 20;

export const shouldDisableZoomInButton = ({
  zoomLevel,
  isSatelliteView,
}: {
  zoomLevel?: number;
  isSatelliteView?: boolean;
}) => {
  const maximumZoomLevel = isSatelliteView
    ? MAXIMUM_ZOOM_LEVEL_SATELLITE
    : MAXIMUM_ZOOM_LEVEL_DEFAULT;
  if (!zoomLevel) return false;
  return zoomLevel >= maximumZoomLevel;
};

export const ZoomButtons = () => {
  const { map, isLoading, google } = useContext(PcaMapContext);
  const [zoomLevel, setZoomLevel] = useState<number | undefined>();
  const [mapType, setMapType] = useState<string>();
  useEffect(() => {
    map?.addListener('zoom_changed', () => {
      setZoomLevel(map?.getZoom());
    });
    map?.addListener('maptypeid_changed', () => {
      setMapType(map?.getMapTypeId());
    });
    // no need to remove event listener here because eventually all the event listener will be removed at usePcaMap
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
  const zoomIn = () => {
    const currentZoomLevel = map?.getZoom();
    if (typeof currentZoomLevel === 'number') map?.setZoom(currentZoomLevel + 1);
  };
  const zoomOut = () => {
    const currentZoomLevel = map?.getZoom();
    if (typeof currentZoomLevel === 'number') map?.setZoom(currentZoomLevel - 1);
  };

  return (
    <StyledZoomButtons>
      <ZoomInButton
        compact
        hideLabel
        onClick={zoomIn}
        variant="map-icon"
        sizeVariant="medium"
        icon={<Plus />}
        disabled={
          !map ||
          shouldDisableZoomInButton({
            zoomLevel,
            isSatelliteView: mapType === google?.maps.MapTypeId.SATELLITE,
          })
        }
      >
        Zoom In
      </ZoomInButton>
      <ZoomOutButton
        hideLabel
        compact
        onClick={zoomOut}
        variant="map-icon"
        sizeVariant="medium"
        icon={<Minus />}
        disabled={!map || zoomLevel === MINIMUM_ZOOM_LEVEL}
      >
        Zoom Out
      </ZoomOutButton>
    </StyledZoomButtons>
  );
};
